import { createStore, Effect } from 'effector';

import { applyReducers, DoneHandler } from '@m/effector-utils';
import { APIResponse } from '@m/utils/http';

import { getIntakePartnerDetailsByUserId } from './actions';

type State = {
  intakePartnerDetails: {
    address?: string;
    city?: string;
    enterpriseId?: number;
    id: number;
    name: string;
    phoneNumber?: string;
    siteId?: number;
    state?: string;
    zipcode?: string;
  } | null;
};

const initialState: State = {
  intakePartnerDetails: null,
};

const store = createStore(initialState);

type Reducers = {
  getIntakePartnerDetailsByUserId: {
    action: Effect<Parameters<typeof getIntakePartnerDetailsByUserId>[0], APIResponse>;
    done: DoneHandler<Parameters<typeof getIntakePartnerDetailsByUserId>[0], State>;
  };
};

export const reducers: Reducers = {
  getIntakePartnerDetailsByUserId: {
    action: getIntakePartnerDetailsByUserId,
    done: (state, { result: { success, data } }) => ({
      ...state,
      intakePartnerDetails: success ? data : null,
    }),
  },
};

export default applyReducers({ storeName: 'request/intake', store, reducers });
